import { TextInput } from 'src/components/atoms/text-input'
import { SelectOutlinedInputChildren } from 'src/components/atoms/select-outlined-children'
import { scalarTypesList } from 'src/constants/modelForm'
import { Listbox } from '@headlessui/react'
import { Button } from 'src/components/atoms/button'
import { CheckboxInput } from 'src/components/atoms/checkbox-input'
import React from 'react'
import { ReactComponent as TrashBinIcon } from 'src/assets/icons/trash-bin.svg'
import { CustomRowField } from 'src/components/organisms/service-builder/wizard/appsync/DefineModels/CustomTypeForm'

export const CustomFieldsRow: React.FC<{
  row: CustomRowField
  fieldNameHandler: (e: Event | any, row: CustomRowField) => void
  fieldTypeHandler: (e: Event | any, row: CustomRowField) => void
  fieldRequiredHandler: (e: Event | any, row: CustomRowField) => void
  fieldArrayHandler: (e: Event | any, row: CustomRowField) => void
  confirmFieldDelete: (row: CustomRowField) => void
}> = props => {
  const { row, confirmFieldDelete, fieldArrayHandler, fieldRequiredHandler, fieldNameHandler, fieldTypeHandler } = props

  return (<div className={'flex items-center justify-between border-t-[1px] border-[#2B2D31]'}>
    <TextInput
      required
      value={row.name}
      disabled={row.isDisabled}
      onChange={(e) => {
        fieldNameHandler(e, row)
      }}
      labelText={'Name:'}
      showRequired
      id="resourceName"
    />
    <SelectOutlinedInputChildren
      classname={'w-1/5'}
      handleValueChange={(e) => {
        fieldTypeHandler(e, row)
      }}
      showRequired={true}
      labelText={'Type:'}
      selected={row.type}
      disabled={row.isDisabled}
    >
      <div className={'text-sm p-[8px] font-bold text-white'}>Scalar Types</div>
      {scalarTypesList?.map((o, index) => (
        <Listbox.Option
          key={index}
          className={({ active }) => `text-white text-xs relative cursor-pointer select-none py-[8px] px-[8px] ${active ? 'bg-[#7E858F]' : 'bg-[#2B2D31]'} `}
          value={o.type}
        >
          {o.type}
        </Listbox.Option>
      ))}
    </SelectOutlinedInputChildren>

    <CheckboxInput labelClassName={'mt-[28px]'}
                   inputClassName={'mt-[28px]'}
                   isActiveDisabled={row.isDisabled === row.required}
                   labelText={'Required'} disabled={row.isDisabled}
                   onChange={(e) => { fieldRequiredHandler(e, row) }}
                   checked={row.required}/>
    <CheckboxInput labelText={'Array'}
                   isActiveDisabled={row.isDisabled === row.array}
                   labelClassName={'mt-[28px]'} inputClassName={'mt-[28px]'}
                   disabled={row.isDisabled}
                   checked={row.array}
                   onChange={(e) => { fieldArrayHandler(e, row) }}
    />
    <Button classname={'mt-[28px]'} iconLeft={<TrashBinIcon/>} disabled={row.isDisabled} onClick={ () => { confirmFieldDelete(row) }} variant={'darker'} title={'Delete Row'} type={'button'}/>
  </div>)
}
